"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasError = void 0;
const matchCode = (input, code) => {
    if (!input)
        return false;
    return Array.isArray(code)
        ? code.includes(input)
        : input === code;
};
const hasError = (error, code, status = 400) => error?.response?.status === status &&
    matchCode(error.response?.data?.code, code);
exports.hasError = hasError;
